import React from "react";
import TextareaAutosize, {
  TextareaAutosizeProps,
} from "react-textarea-autosize";
import {
  EmailSubjectKeysType,
  SharedHistory,
} from "../hook/useEmailEditorHistory";
import useSubjectHistory from "../hook/useSubjectHistory";

type ResizebleTextAreaProps = TextareaAutosizeProps & {
  hasBorder?: boolean;
  sharedHistoryRef?: React.MutableRefObject<SharedHistory>;
  id: EmailSubjectKeysType;
};

/**
 * @comment use only for email text area
 */
export default function ResizebleTextArea({
  sharedHistoryRef,
  placeholder,
  style,
  hasBorder,
  onChange,
  value,
  id,
  ...props
}: ResizebleTextAreaProps): JSX.Element {
  const ref = useSubjectHistory(id, sharedHistoryRef, onChange);

  return (
    // @ts-ignore
    <TextareaAutosize
      placeholder={placeholder}
      {...props}
      onChange={(e) => {
        sharedHistoryRef.current.instances[id].save(e.target.value);
        onChange(e);
      }}
      value={value}
      className={hasBorder ? "border-hover" : ""}
      style={{
        width: "100%",
        outline: "none",
        fontSize: "14px",
        padding: "5px",
        color: "#2f2f2f",
        resize: "none",
        border: "none",
        ...style,
      }}
      maxRows={99999}
      id={id}
      ref={ref}
    />
  );
}
